import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() total = 0;
  @Input() pageSize = 7;
  @Output() pageIndex = new EventEmitter<number>();

  ngOnInit(): void {
    // do something
  }

  pageIndexChange(event: number) {
    this.pageIndex.emit(event);
  }
}
